import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService }      from '../services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { OnScreenMessageService } from '../services/onScreenMessage/onScreenMessage.sevice';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardAdmin implements CanActivate {
  constructor(private authService: AuthService, private router: Router, private onScreenMessageService: OnScreenMessageService, private   translate: TranslateService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
    let url: string = state.url;
    return this.checkAdmin(url);
  }

  checkAdmin(url: string): boolean {
    let user = JSON.parse(localStorage.getItem('user'));
    if (user.userRole == 'ADMIN') {
        return true;
       } else {
      this.router.navigateByUrl('/Home');
      this.onScreenMessageService.Error(this.translate.instant('Unauthorised'));
      return false;
    }

  }
}
